var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('default-count-card',{staticStyle:{"height":"100%"},attrs:{"value":_vm.data,"title":_vm.item_title,"title_class":_vm.title_class,"icon":_vm.item_icon,"icon_color":_vm.icon_color,"not_rounded":""},scopedSlots:_vm._u([{key:"extra",fn:function(){return undefined},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }